import React, { createContext, useState, useContext, useEffect } from 'react';
import axios from 'axios';

const GlobalErrorContext = createContext();

export const useGlobalError = () => useContext(GlobalErrorContext);

export const GlobalErrorProvider = ({ children }) => {
    const [isServerError, setIsServerError] = useState(false);
    const [isInterceptorSetup, setIsInterceptorSetup] = useState(false);

    useEffect(() => {
        // Add a response interceptor
        const interceptor = axios.interceptors.response.use(
            (response) => response,
            (error) => {
                if (
                    error.message === 'Network Error' ||
                    error.code === 'ERR_NETWORK' ||
                    (error.response && error.response.status >= 501)
                ) {
                    setIsServerError(true);
                }
                return Promise.reject(error);
            }
        );

        setIsInterceptorSetup(true);

        // Cleanup the interceptor when the component unmounts
        return () => {
            axios.interceptors.response.eject(interceptor);
        };
    }, []);

    if (!isInterceptorSetup) {
        return null; // Or a simple loading spinner if preferred, but null is fine for initialization
    }

    return (
        <GlobalErrorContext.Provider value={{ isServerError, setIsServerError }}>
            {children}
        </GlobalErrorContext.Provider>
    );
};
